import React, { useState } from 'react';
import FusionCharts from "fusioncharts";
import Maps from "fusioncharts/fusioncharts.maps";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import ReactFC from "react-fusioncharts";
import { notification } from 'antd'; // Importa el componente Notification

// Importa el mapa del Cauca
import CaucaMap from "fusioncharts/maps/fusioncharts.cauca";

// Registra los mapas con FusionCharts
ReactFC.fcRoot(FusionCharts, Maps, FusionTheme, CaucaMap);


// Lista de municipios con IDs de FusionCharts
const municipiosFusion = [
    { id: "CO.CA.AL", nombre: "Almaguer" },
    { id: "CO.CA.AR", nombre: "Argelia" },
    { id: "CO.CA.BB", nombre: "Balboa" },
    { id: "CO.CA.BO", nombre: "Bolívar" },
    { id: "CO.CA.BA", nombre: "Buenos Aires" },
    { id: "CO.CA.CJ", nombre: "Cajibío" },
    { id: "CO.CA.CD", nombre: "Caldono" },
    { id: "CO.CA.CT", nombre: "Caloto" },
    { id: "CO.CA.CO", nombre: "Corinto" },
    { id: "CO.CA.ET", nombre: "El Tambo" },
    { id: "CO.CA.FL", nombre: "Florencia" },
    { id: "CO.CA.GU", nombre: "Guapi" },
    { id: "CO.CA.IN", nombre: "Inzá" },
    { id: "CO.CA.JA", nombre: "Jambaló" },
    { id: "CO.CA.LS", nombre: "La Sierra" },
    { id: "CO.CA.LV", nombre: "La Vega" },
    { id: "CO.CA.LO", nombre: "López de Micay" },
    { id: "CO.CA.ME", nombre: "Mercaderes" },
    { id: "CO.CA.MI", nombre: "Miranda" },
    { id: "CO.CA.MO", nombre: "Morales" },
    { id: "CO.CA.PD", nombre: "Padilla" },
    { id: "CO.CA.PZ", nombre: "Páez" },
    { id: "CO.CA.PA", nombre: "Patía" },
    { id: "CO.CA.PM", nombre: "Piamonte" },
    { id: "CO.CA.PI", nombre: "Piendamó" },
    { id: "CO.CA.PO", nombre: "Popayán" },
    { id: "CO.CA.PT", nombre: "Puerto Tejada" },
    { id: "CO.CA.PU", nombre: "Puracé" },
    { id: "CO.CA.RO", nombre: "Rosas" },
    { id: "CO.CA.SS", nombre: "San Sebastián" },
    { id: "CO.CA.SN", nombre: "Santander de Quilichao" },
    { id: "CO.CA.SR", nombre: "Santa Rosa" },
    { id: "CO.CA.SI", nombre: "Silvia" },
    { id: "CO.CA.SO", nombre: "Sotará" },
    { id: "CO.CA.SU", nombre: "Suárez" },
    { id: "CO.CA.SC", nombre: "Sucre" },
    { id: "CO.CA.TM", nombre: "Timbío" },
    { id: "CO.CA.TQ", nombre: "Timbiquí" },
    { id: "CO.CA.TR", nombre: "Toribío" },
    { id: "CO.CA.TT", nombre: "Totoró" },
    { id: "CO.CA.VR", nombre: "Villa Rica" },
];

// Función para procesar los proyectos
const procesarDatosMunicipios = (data, municipioSeleccionado, municipioSeleccionadopadre) => {
    // Calcula el número de proyectos y otros datos por municipio basándose en nombres
    const municipiosInfo = data.reduce((acc, proyecto) => {
        proyecto.municipios.forEach((municipio) => {
            if (!acc[municipio.nomMunicipio]) {
                acc[municipio.nomMunicipio] = {
                    cantidadProyectos: 0,
                    proyectosNuevos: 0,
                    otrasVigencias: 0,
                    inversionTotal: 0,
                };
            }

            acc[municipio.nomMunicipio].cantidadProyectos += 1;
            acc[municipio.nomMunicipio].inversionTotal += proyecto.total;

            // Clasificar proyecto como nuevo o de otras vigencias
            if (proyecto.vigenciaInicial >= 2024) {
                acc[municipio.nomMunicipio].proyectosNuevos += 1;
            } else {
                acc[municipio.nomMunicipio].otrasVigencias += 1;
            }
        });
        return acc;
    }, {});

    // Mapear los datos al formato de FusionCharts
    return municipiosFusion.map((municipio) => {
        const info = municipiosInfo[municipio.nombre] || {
            cantidadProyectos: 0,
            proyectosNuevos: 0,
            otrasVigencias: 0,
            inversionTotal: 0,
        };

        return {
            id: municipio.id,
            value: info.cantidadProyectos,
            displayValue: municipio.nombre,
            toolText: `<div style='font-size:14px; text-align:left; color:#333;'>\
                <b style='font-size:16px; color:#000;'>${municipio.nombre}</b>\
                <br/>\
                <span style='font-size:14px; color:#555;'>Cantidad de proyectos:</span> \
                <b style='font-size:14px; color:#007BFF;'>${info.cantidadProyectos}</b>\
                <br/>\
                <span style='font-size:14px; color:#555;'>Inversión total:</span> \
                <b style='font-size:14px; color:#007BFF;'>$ ${info.inversionTotal.toLocaleString()}</b>\
                <br/>\
                <span style='font-size:14px; color:#555;'>Proyectos nuevos:</span> \
                <b style='font-size:14px; color:#28a745;'>${info.proyectosNuevos}</b>\
                <br/>\
                <span style='font-size:14px; color:#555;'>Otras vigencias:</span> \
                <b style='font-size:14px; color:#dc3545;'>${info.otrasVigencias}</b>\
            </div>`,
            color:
                municipioSeleccionado === municipio.id || municipioSeleccionadopadre === municipio.nombre
                    ? "#FFC533" // Color amarillo si está seleccionado por el hijo o el padre
                    : "#adb5bd", // Color predeterminado

        };
    });
};

const MapaCaucaDepartamento = ({ data, onMunicipioClick, municipioSeleccionadopadre }) => {

    const [municipioSeleccionado, setMunicipioSeleccionado] = useState(null);

    const municipiosData = procesarDatosMunicipios(data, municipioSeleccionado, municipioSeleccionadopadre);
    console.log("Municipio que llega: " + municipioSeleccionadopadre)

    const dataSource = {
        chart: {
            caption: "Departamento del Cauca",
            theme: "fusion",
            entityFillHoverColor: "#FFC533",
            showBorder: "1",
            borderColor: "#000000",
            nullEntityColor: "#cccccc",
            nullEntityAlpha: "50",
            numbersuffix: "",
            showlabels: "1",
            borderthickness: "0.4",
            baseFont: "Arial",
            baseFontSize: "10",
            baseFontColor: "#333333",
            captionFontSize: "14",
            subCaptionFontSize: "12",
            useHoverColor: "1", // Activa el color de hover
            hoverCursor: "pointer", // Cambia el cursor al pasar sobre una entidad

        },
        colorRange: {
            gradient: "1",
            minvalue: "0",
            code: "#e8f4fd",
            color: [
                {
                    minvalue: "0",
                    maxvalue: "20",
                    code: "#b7e4c7",
                    alpha: "100",
                    label: "Muy bajo",
                },
                {
                    minvalue: "21",
                    maxvalue: "50",
                    code: "#74c69d",
                    alpha: "100",
                    label: "Bajo",
                },
                {
                    minvalue: "51",
                    maxvalue: "75",
                    code: "#40916c",
                    alpha: "90",
                    label: "Moderada",
                },
                {
                    minvalue: "76",
                    maxvalue: "100",
                    code: "#1b4332",
                    alpha: "80",
                    label: "Alta",
                },
            ],
            colorScaleLabelFont: "Arial",
            colorScaleLabelFontSize: "12",
            colorScaleLabelFontColor: "#000000",
            colorScaleBorderThickness: "2",
            colorScaleBorderColor: "#aaaaaa",
            colorScaleFillAlpha: "100",
            colorScaleGap: "5",
        },

        data: municipiosData,
    };

    const eventHandlers = {
        entityClick: (evt, data) => {
            const municipioId = data.id.toUpperCase(); // Normaliza a mayúsculas
            const municipioInfo = municipiosFusion.find(
                (municipio) => municipio.id.toUpperCase() === municipioId
            );

            if (municipioInfo) {
                if (municipioSeleccionado === municipioId) {
                    // Si el municipio ya está seleccionado, enviar "Cauca" al padre
                    if (onMunicipioClick) {
                        onMunicipioClick("Cauca");
                        notification.info({
                            message: 'Municipio Deseleccionado',
                            description: `Has deseleccionado el municipio y vuelto al nivel Cauca.`,
                            placement: 'top',
                            duration: 3, // Tiempo en segundos que la notificación estará visible
                        });
                    }
                    setMunicipioSeleccionado(null); // Deseleccionar el municipio
                } else {
                    // Si es un nuevo municipio seleccionado
                    setMunicipioSeleccionado(municipioId); // Marca el municipio seleccionado
                    if (onMunicipioClick) {
                        onMunicipioClick(municipioInfo.nombre); // Envía el nombre al padre
                        notification.info({
                            message: 'Municipio Seleccionado',
                            description: `Has seleccionado el municipio: ${municipioInfo.nombre}`,
                            placement: 'top',
                            duration: 3, // Tiempo en segundos que la notificación estará visible
                        });
                    }
                }
            } else {
                console.warn(`No se encontró el municipio con ID: ${municipioId}`);
            }
        },
    };


    return (
        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            <ReactFC
                type="maps/cauca"
                width="100%"
                height="600"
                dataFormat="JSON"
                dataSource={dataSource}
                events={eventHandlers} // Configura los eventos
            />
        </div>
    );
};

export default MapaCaucaDepartamento;
